import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import User from '../../images/user.jpg';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';

function SubSuccessScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ 'f_name': '', 'l_name': '', 'm_name': '', 'streak': '', 'dob': '', 'classes': [], 'attendance': 0 });

    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/manage-child/child-profile.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setProfileData({'f_name': response.data.results.first_name, 'l_name': response.data.results.last_name, 'm_name': response.data.results.middle_name, 'streak': response.data.results.streak, 'classes': response.data.results.active_classes_enrrolled, 'attendance': response.data.results.attendance });
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto h-[-webkit-fill-available]">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full h-auto mt-[15%] flex flex-col justify-center items-center'>
                    <div className="content">
                        <svg width="200" height="200">
                            <circle
                            fill="none"
                            stroke="#F4D00F"
                            strokeWidth="10"
                            cx="100"
                            cy="100"
                            r="90"
                            strokeLinecap="round"
                            transform="rotate(-90 100 100)"
                            className="circle"
                            />
                            <polyline
                            fill="none"
                            stroke="#F4D00F"
                            points="55,107 90,135 152,69"
                            strokeWidth="12"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="tick"
                            />
                        </svg>
                    </div>
                    <a className='font-semibold text-md my-5'>Thank you! Subscription successful</a>
                    <ButtonSmall loading={false} onPress={() => navigate('/my-classes')} label={'Go To Classes'} />
                </div>
            </main>
        </div>
    </div>
  );
}

export default SubSuccessScreen;
